import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Modal, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';

import {
  IntegerFractionalField,
  InputField,
  CheckboxField,
} from 'Common/SemanticWrapper';
import { RECIPE_PREPARATION_FORM_NAME, InputMode } from 'Common/FormEnum';
import { RecipePreparationReportEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';

import * as EditRecipeSelectors from '../state/editrecipe/selectors';

class RecipePreparationReportModal extends Component {
  static propTypes = {
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
    headerTitle: PropTypes.string.isRequired,
  };

  render() {
    const {
      headerTitle,
      modalProps,
      reportFetching,
      submit,
      change,
      formValues,
    } = this.props;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header ">
          {headerTitle}
          <Icon link name="close" onClick={modalProps.onClose} />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <Grid padded>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  component={IntegerFractionalField}
                  label={'Serving Size'}
                  name={Fields.QtyOfPortion}
                  fluid
                  hideEmptyError
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  component={InputField}
                  label={'Serving Unit'}
                  name={Fields.MeasureOfPortion}
                  fluid
                  hideEmptyError
                  disabled
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid padded>
            <Grid.Row>
              <Grid.Column>
                <label>Default Recipe Yield:</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  label={'# of Servings'}
                  name={Fields.DefaultNumberOfPortion}
                  mode={InputMode.Decimal}
                  numericSize={[8, 2]}
                  fluid
                  disabled
                  hideEmptyError
                />
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="bottom">
                <Field
                  component={CheckboxField}
                  label={'Lock Batch'}
                  name={Fields.LockBatch}
                  disabled
                  infoMessage={`If the Recipe has a locked batch then the recipe can only be incremented by increasing the # of batches. When the number of batches is entered the corresponding # of servings will display in the the "# of Servings" box`}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <label>Scale Recipe Yield to:</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  label={'# of Servings'}
                  name={Fields.NumberOfPortion}
                  mode={InputMode.Decimal}
                  numericSize={[8, 2]}
                  fluid
                  disabled={Boolean(formValues[Fields.LockBatch])}
                />
              </Grid.Column>

              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  label={'Batches'}
                  name={Fields.Batches}
                  mode={InputMode.Integer}
                  fluid
                  onChange={e => {
                    const value = e.target.value || 0;
                    const numberOfPortion = _.multiply(
                      formValues[Fields.DefaultNumberOfPortion],
                      value
                    );
                    change(Fields.NumberOfPortion, numberOfPortion);
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <div className="manage-menu-header-buttons">
            <Button
              className="mnm-button-blue"
              onClick={submit}
              loading={reportFetching}
              disabled={reportFetching}
            >
              View Report
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  formValues: EditRecipeSelectors.getRecipePrepFormValues(state) || {},
});

RecipePreparationReportModal = connect(mapStateToProps)(
  RecipePreparationReportModal
);

const validate = values => {
  const errors = {};

  if (!values[Fields.RecipeId]) {
    errors[Fields.RecipeId] = 'Recipe Id is required.';
  }

  if (!values[Fields.QtyOfPortion]) {
    errors[Fields.QtyOfPortion] = 'Serving Size is required.';
  }

  if (!values[Fields.MeasureOfPortion]) {
    errors[Fields.MeasureOfPortion] = 'Serving Unit is required.';
  }

  if (!values[Fields.Batches]) {
    errors[Fields.Batches] = 'Batches is required.';
  }

  if (!values[Fields.NumberOfPortion]) {
    errors[Fields.NumberOfPortion] = '# of Servings is required.';
  }
  return errors;
};

RecipePreparationReportModal = reduxForm({
  form: RECIPE_PREPARATION_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(RecipePreparationReportModal);

RecipePreparationReportModal = withReportSubscription(
  RecipePreparationReportModal
);

export { RecipePreparationReportModal };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/RecipePreparationReportModal.js